module.exports = __webpack_public_path__ + "img/icon-type-word.67bf9e03.svg";